import { Injectable } from '@angular/core';
import { environment as ENV } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CrudService } from '../crud.service';
import { CatalogDiagnosticMasterFilter, CatalogDiagnosticMasterRequest, CatalogDiagnosticMasterResponse } from '../../models/catalog/diagnostic.master.dto';
import { Pageable } from '../../models/response.model';
import { userSession } from '../../constants/names-local.constants';
import { urlServiceConsumerKafka } from '../../constants/consumer-kafka.constants';

@Injectable({
  providedIn: 'root'
})
export class DiagnosticMasterService extends CrudService {


  constructor(
    protected override http: HttpClient,
  ) {
    super(http);
  }

  public async getAll(filters: CatalogDiagnosticMasterFilter, loading?: boolean): Promise <Pageable<CatalogDiagnosticMasterResponse[]>| null> {    
    let params = new HttpParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] != null && filters[key] != undefined && filters[key] != '') {
        params = params.append(key, filters[key]);
      }
    });

    if(loading === undefined)
      loading = true;
    else
      loading = false;

    let branchOfficeId = localStorage.getItem(userSession.idbranch)
    
    return await this.get<Pageable<CatalogDiagnosticMasterResponse[]>>(
      urlServiceConsumerKafka.catDiagnosticMaster.list
      .replace('{branchOfficeId}', String(branchOfficeId)), params, loading)
  }


  public async getBy(id: number): Promise <CatalogDiagnosticMasterResponse| null>{        
    return await this.get<CatalogDiagnosticMasterResponse>(
    urlServiceConsumerKafka.catDiagnosticMaster.one
      .replace('{diagnosticId}', String(id)))
  }


  public async add(request: CatalogDiagnosticMasterRequest): Promise<number | null> {
    request.branchOfficeId = Number(localStorage.getItem(userSession.idbranch) || 1)    
    return await this.post<number>(
    urlServiceConsumerKafka.catDiagnosticMaster.add, request)
  }


  public async edit(id: number, request: CatalogDiagnosticMasterRequest): Promise<void> {
    request.idDiagnostico = Number(id);    
    await this.patch<void>(urlServiceConsumerKafka.catDiagnosticMaster.edit, request)
  }


  public async deleteById(id: number): Promise<void> {
    await this.delete( urlServiceConsumerKafka.catDiagnosticMaster.delete
    .replace('{diagnosticId}', String(id)))

  }
}
